import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';

import { CampanhaVisualizacaoComponent } from './campanha-visualizacao.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CampanhaVisualizacaoComponent
    ],
    exports: [
        CampanhaVisualizacaoComponent
    ]
})
export class CampanhaVisualizacaoModule { }
